import { useEffect, useState } from 'react';

import type { GridApiPro } from '@mui/x-data-grid-pro/models';

export const useGetVisibleXDataGridProColumns = (
  gridApiContext: GridApiPro,
) => {
  const [gridTemplateColumns, setGridTemplateColumns] = useState(() =>
    gridApiContext?.getVisibleColumns(),
  );

  useEffect(() => {
    const unsub = gridApiContext.subscribeEvent('debouncedResize', () =>
      setGridTemplateColumns(gridApiContext?.getVisibleColumns()),
    );

    return unsub;
  }, [gridApiContext]);

  return { gridTemplateColumns };
};
